module.exports = __webpack_public_path__ + "static/media/heart-half.311916ed.svg";